<template>
  <div class=" placeholder-glow my-4" aria-hidden="true">
    <div class="row mb-4">
      <div
        class="col w-50 d-flex flex-column justify-content-start align-items-start"
      >
        <h1 class="placeholder w-75 pb-2 skeleton rounded">&nbsp;</h1>
        <h3 class="placeholder w-50 skeleton rounded">&nbsp;</h3>
      </div>
      <div
        class="col w-50 d-flex flex-column justify-content-start align-items-end"
      >
        <h3 class="placeholder w-75 pb-2 skeleton rounded">&nbsp;</h3>
        <h3 class="placeholder w-50 pb-2 skeleton rounded">&nbsp;</h3>

        <span class="placeholder w-25 mb-1 skeleton rounded lh-1">&nbsp;</span>
        <span class="placeholder w-25 skeleton rounded lh-1">&nbsp;</span>
      </div>
    </div>
    <div v-if="photoUrlPrefix" class="row mb-4 mt-2">
      <div class="col w-50 skeleton skeleton-image my-2 mx-2"></div>
      <div class="col d-flex flex-column align-items-center w-50 mt-4">
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <h2 class="placeholder w-50 skeleton mb-1 rounded">&nbsp;</h2>
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <span class="placeholder w-50 skeleton rounded mb-1 lh-1"
            >&nbsp;</span
          >
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
        <div class="col d-flex flex-column w-100 align-items-center mt-4">
          <h1 class="placeholder w-40 bg-primary rounded mb-4">
            &nbsp;
          </h1>
          <h1 v-if="lteInstalled" class="placeholder w-40 bg-primary rounded">
            &nbsp;
          </h1>
        </div>
      </div>
    </div>
    <div v-else class="row mb-4">
      <div class="col d-flex flex-column w-50 align-items-end ">
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <h2 class="placeholder w-50 skeleton mb-1 rounded">&nbsp;</h2>
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <span class="placeholder w-50 skeleton rounded mb-1 lh-1"
            >&nbsp;</span
          >
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
        <div class="col d-flex flex-column w-50 align-items-center mb-3">
          <span class="placeholder w-50 skeleton rounded lh-1">&nbsp;</span>
        </div>
      </div>
      <div
        class="col d-flex flex-column w-50 align-items-start justify-content-center ps-0"
      >
        <h1 class="placeholder w-40 bg-primary rounded mb-4">&nbsp;</h1>
        <h1 v-if="lteInstalled" class="placeholder w-40 bg-primary rounded">
          &nbsp;
        </h1>
      </div>
    </div>
    <div v-if="showMap" class="row my-4">
      <div class="col w-100 placeholder skeleton mx-2 my-4 skeleton-map"></div>
    </div>
  </div>
</template>
<style scoped></style>
<script>
export default {
  props: {
    photoUrlPrefix: {
      type: String,
      required: true,
    },
    lteInstalled: {
      type: Boolean,
      required: true,
    },
    showMap: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
